(function () {
  'use strict';

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart add failed');
      return r.json();
    });
  }

  function refreshCartUI() {
    // Konko fix 15-sep-2026: cart:refresh / cart:updated / ajaxCart.afterCartLoad
    // NO existen en este tema (Impulse no los escucha y el drawer nunca se enteraba).
    // Los eventos reales del CartDrawer del tema son:
    //   cart:build -> reconstruye el drawer con el carrito fresco
    //   cart:open  -> lo abre
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  function setBtnLoading(btn, loading) {
    if (!btn) return;
    btn.disabled = loading;
    btn.classList.toggle('is-loading', loading);
  }

  /* ----------------------------------------------------------------
     Mecanismo único y seguro para agregar al carrito reusando el
     MISMO formulario y botón reales de la ficha de producto
     (form[action="/cart/add"] + [data-add-to-cart]), para que el
     theme haga exactamente lo que hace con su propio botón: agregar,
     redibujar el carrito lateral, subtotal, contador y envío gratis,
     y recién ahí abrir el drawer.

     Soporta agregar una variante que NO es la del producto actual
     (p.ej. la polera del upsell BOGO) inyectando temporalmente una
     <option> en el <select name="id"> real (está oculto por CSS,
     así que no hay parpadeo visual) y restaurando todo de inmediato
     en el mismo ciclo síncrono, antes de que el navegador repinte.

     Devuelve true si pudo iniciar el flujo real (y entonces SIEMPRE
     llama a onDone cuando termina); devuelve false si no encontró el
     formulario/botón real, para que el que llama use un fallback.
     ---------------------------------------------------------------- */
  function kkAddViaMainForm(variantId, quantity, onDone) {
    var realForm = document.querySelector('form[action="/cart/add"]');
    if (!realForm) return false;

    var idField = realForm.elements ? realForm.elements.namedItem('id') : null;
    var qtyField = realForm.elements ? realForm.elements.namedItem('quantity') : null;
    var realSubmitBtn = realForm.querySelector('[data-add-to-cart]');
    if (!idField || !realSubmitBtn) return false;

    var isSelect = idField.tagName === 'SELECT';
    var originalId = idField.value;
    var originalQty = qtyField ? qtyField.value : null;
    var tempOption = null;

    if (isSelect) {
      var hasOption = Array.prototype.some.call(idField.options, function (o) {
        return o.value === String(variantId);
      });
      if (!hasOption) {
        tempOption = document.createElement('option');
        tempOption.value = String(variantId);
        idField.appendChild(tempOption);
      }
    }

    idField.value = String(variantId);
    idField.dispatchEvent(new Event('change', { bubbles: true }));
    if (qtyField) qtyField.value = quantity || 1;

    realSubmitBtn.click();

    // Restaura de inmediato la selección/cantidad originales del form
    // principal (síncrono, antes de cualquier repintado: sin parpadeo
    // y sin riesgo de alterar lo que el cliente tenía seleccionado).
    idField.value = originalId;
    if (tempOption) tempOption.remove();
    idField.dispatchEvent(new Event('change', { bubbles: true }));
    if (qtyField && originalQty !== null) qtyField.value = originalQty;

    var released = false;
    var finish = function () {
      if (released) return;
      released = true;
      onDone();
    };

    // El botón real se deshabilita mientras el theme procesa el agregado;
    // cuando vuelve a habilitarse, avisamos que terminó.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (!realSubmitBtn.disabled) {
          mo.disconnect();
          finish();
        }
      });
      mo.observe(realSubmitBtn, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }
    // Seguro máximo por si el theme no vuelve a habilitar el botón (p.ej. error de red).
    setTimeout(finish, 6000);

    return true;
  }

  function initBogo() {
    var root = document.querySelector('[data-kk-bogo]');
    if (!root) return;
    var btn = root.querySelector('[data-kk-bogo-add]');
    var variantInput = root.querySelector('[data-kk-bogo-variant]');
    if (!btn || !variantInput) return;

    btn.addEventListener('click', function () {
      if (btn.dataset.kkSubmitting === '1') return;
      var variantId = variantInput.value;
      if (!variantId) return;

      btn.dataset.kkSubmitting = '1';
      setBtnLoading(btn, true);

      var release = function () {
        setBtnLoading(btn, false);
        btn.dataset.kkSubmitting = '';
      };

      var started = kkAddViaMainForm(variantId, 1, release);

      if (!started) {
        // Fallback (no debería ocurrir en la página de producto): comportamiento anterior.
        addToCart([{ id: variantId, quantity: 1 }])
          .then(function () { refreshCartUI(); })
          .catch(function () { alert('No se pudo agregar la polera. Intenta nuevamente.'); })
          .finally(release);
      }
    });
  }

  function initBundle() {
    var root = document.querySelector('[data-kk-bundle]');
    if (!root) return;
    var btn = root.querySelector('[data-kk-bundle-add]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (btn.dataset.kkSubmitting === '1') return;

      var mainVariant = btn.getAttribute('data-main-variant');
      var items = [];
      if (mainVariant) items.push({ id: mainVariant, quantity: 1 });
      root.querySelectorAll('[data-kk-bundle-variant]').forEach(function (input) {
        if (input.value) items.push({ id: input.value, quantity: 1 });
      });
      if (!items.length) return;

      btn.dataset.kkSubmitting = '1';
      setBtnLoading(btn, true);

      var release = function () {
        setBtnLoading(btn, false);
        btn.dataset.kkSubmitting = '';
      };

      var fallbackAll = function () {
        addToCart(items)
          .then(function () { refreshCartUI(); })
          .catch(function () { alert('No se pudo agregar el combo. Intenta nuevamente.'); })
          .finally(release);
      };

      // El formulario real solo admite una variante por envío, así que
      // el combo agrega cada producto con un click real en secuencia
      // (uno termina -> se dispara el siguiente), usando siempre el
      // mismo mecanismo que el botón principal del theme.
      var i = 0;
      var addNext = function () {
        if (i >= items.length) { release(); return; }
        var item = items[i++];
        var started = kkAddViaMainForm(item.id, item.quantity, addNext);
        if (!started) {
          fallbackAll();
        }
      };
      addNext();
    });
  }

  function initStockScarcity() {
    var root = document.querySelector('[data-kk-stock-scarcity]');
    if (!root) return;
    var dataEl = document.querySelector('[data-kk-stock-data]');
    var text = root.querySelector('[data-kk-stock-text]');
    var fill = root.querySelector('[data-kk-stock-fill]');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var threshold = data.threshold || 10;

    function update(variantId) {
      var v = data.variants && data.variants[variantId];
      if (!v || !v.tracked) {
        root.classList.add('hide');
        return;
      }
      var qty = v.quantity || 0;
      if (qty > 0 && qty < threshold) {
        root.classList.remove('hide');
        if (text) text.textContent = '¡Apúrate! Quedan ' + qty + ' unidades';
        if (fill) fill.style.width = Math.min(100, (qty * 100) / threshold) + '%';
      } else {
        root.classList.add('hide');
      }
    }

    onVariantChange(update);
  }

  /* ---------------- Sticky ATC + offset compartido ---------------- */
  // Un único ResizeObserver reutilizado para publicar --konko-sticky-buy-offset.
  var kkStickyResizeObserver = null;

  function setStickyOffset(px) {
    document.documentElement.style.setProperty('--konko-sticky-buy-offset', px + 'px');
  }

  function setStickyVisible(bar, visible) {
    if (bar.classList.contains('is-visible') === visible) return;
    bar.classList.toggle('is-visible', visible);
    setStickyOffset(visible ? bar.offsetHeight : 0);
  }

  function initStickyAtc() {
    var bar = document.querySelector('[data-kk-sticky-atc]');
    if (!bar || bar.dataset.kkInit === '1') return;
    bar.dataset.kkInit = '1';

    var sentinel = document.querySelector('form[action="/cart/add"]');

    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // "Ya fue sobrepasado hacia arriba" = su borde inferior quedó
          // por encima del viewport (bottom < 0), no solo "no intersecta".
          var passedAbove = entry.boundingClientRect.bottom < 0;
          setStickyVisible(bar, passedAbove && !entry.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(sentinel);
    } else if (sentinel) {
      // Fallback sin IntersectionObserver: scroll pasivo + rAF, sin cálculos continuos.
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var rect = sentinel.getBoundingClientRect();
          setStickyVisible(bar, rect.bottom < 0);
          ticking = false;
        });
      }, { passive: true });
    }

    // Mantiene el offset sincronizado si el alto de la barra cambia
    // (variante más larga, idioma, ancho de pantalla) mientras está visible.
    if ('ResizeObserver' in window) {
      if (!kkStickyResizeObserver) {
        kkStickyResizeObserver = new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            var el = entry.target;
            if (el.classList.contains('is-visible')) {
              setStickyOffset(el.offsetHeight);
            }
          });
        });
      }
      kkStickyResizeObserver.observe(bar);
    }

    var addBtn = bar.querySelector('[data-kk-sticky-add]');
    var variantSelect = bar.querySelector('[data-kk-sticky-variant]');

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.dataset.kkSubmitting === '1') return;

        var variantId = variantSelect && variantSelect.value;
        if (!variantId) return;

        addBtn.dataset.kkSubmitting = '1';
        setBtnLoading(addBtn, true);

        var release = function () {
          setBtnLoading(addBtn, false);
          addBtn.dataset.kkSubmitting = '';
        };

        var started = kkAddViaMainForm(variantId, 1, release);

        if (!started) {
          // Fallback (no debería ocurrir en la página de producto): comportamiento anterior.
          addToCart([{ id: variantId, quantity: 1 }])
            .then(function () { refreshCartUI(); })
            .catch(function () { alert('No se pudo agregar el producto. Intenta nuevamente.'); })
            .finally(release);
        }
      });
    }

    onVariantChange(function (variantId, variant) {
      if (variantSelect) variantSelect.value = variantId;
      var priceEl = bar.querySelector('[data-kk-sticky-price]');
      if (priceEl && variant && variant.price != null) {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (addBtn) {
        var available = !variant || variant.available !== false;
        addBtn.disabled = !available;
      }
    });
  }

  function initSizeChart() {
    var trigger = document.querySelector('[data-kk-size-trigger]');
    var modal = document.querySelector('[data-kk-size-modal]');
    if (!trigger || !modal || trigger.dataset.kkInit === '1') return;
    trigger.dataset.kkInit = '1';

    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', open);
    modal.querySelectorAll('[data-kk-size-modal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initScrollTop() {
    var btn = document.querySelector('[data-kk-scroll-top]');
    if (!btn || btn.dataset.kkInit === '1') return;
    btn.dataset.kkInit = '1';

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        btn.classList.toggle('is-visible', window.scrollY > 600);
        ticking = false;
      });
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}');
      }
    } catch (e) { /* noop */ }
    return (cents / 100).toFixed(0);
  }

  function onVariantChange(cb) {
    var handled = function (evt) {
      var variant = (evt.detail && (evt.detail.variant || evt.detail)) || null;
      var variantId = variant && (variant.id || variant.variant_id);
      if (variantId) cb(String(variantId), variant);
    };
    ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (name) {
      document.addEventListener(name, handled);
    });

    var mainForm = document.querySelector('form[action="/cart/add"]');
    if (mainForm) {
      mainForm.addEventListener('change', function () {
        var idInput = mainForm.querySelector('input[name="id"]');
        if (idInput && idInput.value) cb(idInput.value, null);
      });
    }
  }

  function boot() {
    initBogo();
    initBundle();
    initStockScarcity();
    initStickyAtc();
    initScrollTop();
    initSizeChart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();